module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModelManagerPage', {
    attrs: {
      "lower-app-name": "emarket",
      "lower-model-name": "order",
      "version": "2",
      "obj-label": "订单"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98ae1452"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/OrderManager.vue
// module id = 382
// module chunks = 1